import type React from "react";
import { Card, CardContent, Typography } from "@mui/material";
import type { SvgIconComponent } from "@mui/icons-material";

interface EmptyWidgetProps {
  title: string;
  description: string;
  icon?: SvgIconComponent | null | "";
}

const EmptyWidget: React.FC<EmptyWidgetProps> = ({
  title,
  description,
  icon,
}) => {
  const Icon = typeof icon === "function" ? icon : null;

  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        boxShadow: 0,
        borderRadius: 3,
      }}
    >
      <CardContent sx={{ textAlign: "center" }}>
        {Icon && <Icon sx={{ fontSize: 48, color: "text.secondary", mb: 2 }} />}
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {description}
        </Typography>
      </CardContent>
    </Card>
  );
};

export default EmptyWidget;
